'use strict';

customerZone.filter('sanitize', ['$sanitize', function($sanitize){
    return function(dirty){
        if (!dirty) return '';
        // Eat '{{ foo }}' and pass the remainder to the regular sanitizer
        return $sanitize(dirty.replace(/{{[^}]*}}/g, ''));
    };
}]);
